import { Area } from "Models/Areas/Area";
import { RoleType } from "Models/Users/RoleType";
import { AuditItemTemplate } from "./AuditItemTemplate";
import { ScoreType } from "./ScoreType";

export class AuditTemplate {
    public id?: number;
    public name: string;
    public description: string;
    public pictureUrl?: string;
    public doubleSignatureRequired: boolean = false;
    public scoreType?: ScoreType = undefined;
    public minTaskScore: number = 0;
    public maxTaskScore: number = 10;
    public area: Area;
    public lastCompletedDate: Date;
    public role: RoleType = RoleType.basic;
    public signatureRequired: boolean = false;
    public createdAt: Date;
    public lastUpdatedAt: Date;
    public items: AuditItemTemplate[] = [];
    public totalInstructionCount: number = 0;
}


// WEBPACK FOOTER //
// ./src/Models/Audit/AuditTemplate.ts